<template>
  <div class="w-100 bg-gray20 m-b-6">
    <div class="container d-flex fd-column p-y-6">
      <div class="h3 text-bold p-x-1:mo p-b-2">
        <div>Find Services You Can Offer</div>
      </div>
      <div class="fd-column:mo ai-center:mo SERVICE-SECTION">
        <occupation-card
            v-for="(occupation, index) in occupationsWithServices"
            :occupation="occupation"
            :key="index"
            :current-index="currentIndex"
            :index="index"
            @handle-click="handleClick(index)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import OccupationCard from './components/OccupationCard';

export default {

  name: 'services-to-offer-section',
  components: { OccupationCard },
  data () {
    return {
      occupations: [],
      services: [],
      associatedServices: [],
      updatedOccupations: [],
      currentIndex: -1,
    };
  },
  computed: {
    ...mapGetters('homepage/contentful', [
      'proHomePage',
    ]),
    ...mapGetters('homepage/proServices', [
      'occupationsWithServices',
    ]),
  },
  methods: {
    handleClick (index) {
      this.currentIndex = this.currentIndex === index ? -1 : index;
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@homeservices/design-kit/tools";

.SERVICE-SECTION {
    display: flex;
    flex: 1 0 357px;
    flex-wrap: wrap;
    justify-content: space-around;
    font-size: 14px;
    align-items: flex-start;
  }
</style>
